export function isWithinRange(date: Date, min: Date | null, max: Date | null) {
  return (!min || date >= min) && (!max || date <= max);
}
